import request from './request'

export const getSiteConfig = () => request.get('/api/portal/site/config')
export const getBanners = () => request.get('/api/portal/banners')
export const getCategories = params => request.get('/api/portal/product/categories', { params })
export const getProducts = params => request.get('/api/portal/products', { params })
export const getProduct = (id, params) => request.get(`/api/portal/products/${id}`, { params })
export const getDealers = () => request.get('/api/portal/dealers')
export const getServiceProviders = () => request.get('/api/portal/service-providers')
export const getCaptcha = () => request.get('/api/portal/captcha')
export const submitContact = data => request.post('/api/portal/contact-submissions', data)
export const recordVisit = data => request.post('/api/portal/statistics/visit', data)
export const recordView = data => request.post('/api/portal/statistics/view', data)
export const recordDownload = data => request.post('/api/portal/statistics/download', data)

export function listData (data) {
  if (Array.isArray(data)) return data
  return (data && (data.records || data.list || data.items)) || []
}

export function sortByOrder (items) {
  return (Array.isArray(items) ? items : []).slice().sort((a, b) => {
    const left = Number(a && a.sortOrder)
    const right = Number(b && b.sortOrder)
    return (Number.isFinite(left) ? left : Number.MAX_SAFE_INTEGER) -
      (Number.isFinite(right) ? right : Number.MAX_SAFE_INTEGER)
  })
}
